import * as React from "react";

interface DisabledIconProps {
    className?: string;
    onClick?: () => void;
}

export class DisabledIcon extends React.Component<DisabledIconProps> {
    render() {
        return (
            <div {...this.props}>

                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1163_8746)">
                        <path d="M8 0.25C3.71875 0.25 0.25 3.71875 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.2812 15.75 15.75 12.2812 15.75 8C15.75 3.71875 12.2812 0.25 8 0.25ZM3.875 9.25C3.66875 9.25 3.5 9.08125 3.5 8.875V7.125C3.5 6.91875 3.66875 6.75 3.875 6.75H12.125C12.3313 6.75 12.5 6.91875 12.5 7.125V8.875C12.5 9.08125 12.3313 9.25 12.125 9.25H3.875Z" fill="#C1272D" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1163_8746">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
        );
    }
}
